import { Injectable } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './financial-institution-search.actions';
import { FinancialInstitutionTypes } from '@models/lender';

@Injectable({
	providedIn: 'root',
})
export class FinancialInstitutionSearchDispatch {
	@Dispatch()
	Search = (
		searchValue: string,
		filters: { [key in FinancialInstitutionTypes]?: boolean },
		filterCS = true,
	): actions.Search => new actions.Search({ searchValue, filters, filterCS });

	@Dispatch()
	Reset = (): actions.Reset => new actions.Reset();
}
